import Socket from '../connection/socket';
import * as SettingsActions from '../stores/actions/settings';
import { socketListenerDispatch } from './socket-listener-main';

function handleUpdateState(message: any) {
	socketListenerDispatch(SettingsActions.replaceState(message.message));
}

export default function Settings(socket: Socket) {
	socket.addListener('settings-update', handleUpdateState);
}
